"use client";

import { useSyncExternalStore } from "react";

let signal = 0;
const listeners = new Set();

export function notifyEditorContentChanged() {
  signal += 1;
  listeners.forEach((listener) => listener());
}

export function resetEditorContentChangeSignal() {
  signal = 0;
  listeners.forEach((listener) => listener());
}

export function subscribeToEditorContentChanges(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function getEditorContentChangeSignal() {
  return signal;
}

export function useEditorContentChangeSignal() {
  return useSyncExternalStore(
    subscribeToEditorContentChanges,
    getEditorContentChangeSignal,
    () => 0,
  );
}
